<template>
    <div class="payroll-mobile">
        <template>
            <!-- Abdullah responsive added mx-3 -->
            <div class="row no-gutters py-2 mb-3 mx-3 custom-mobile-left-side-alignment-margin custom-mobile-padding-left-side-half">
                <div class="col-md-10 col-sm-12">
                    <h4 class="atlhr-dashboard-title mt-10">
                        Tax <span class="black-title">Cards</span>
                        <span>
                            <a v-bind:href="$api_url">Dashboard</a>
                            / Payroll / Tax Cards
                        </span>
                    </h4>
                </div>
            </div>
        </template>
        <!-- Abdullah responsive added mx-3 -->
        <b-overlay rounded="sm" class="mx-3 custom-mobile-left-side-alignment-margin custom-mobile-padding-left-side-half">
            <b-card no-body class="border-0 bg-transparent no-shadow employee-tab-bg">
                <div class="d-inline-block w-100">
                    <div class="row pt-4">
                        <div class="col-md-3">
                            <div class="clearfix company-form-container h-100 p-3 payslip-list-dropdown">
                                <b-form-select v-model="fiscals" class="mb-3" v-on:change="filterFiscalYear">
                                    <b-form-select-option :value='sa'>Select Fiscal Year</b-form-select-option>
                                    <b-form-select-option v-for="(fiscal_year, index) in fiscal_years" :key="index"
                                        :value="fiscal_year.fiscal_year">
                                        {{ fiscal_year.fiscal_year }}
                                    </b-form-select-option>
                                </b-form-select>

                                <b-form-select v-model="selected_month_id" class="" v-on:change="handleMonthSelection">
                                    <b-form-select-option :value='sa'>Select Fiscal Month</b-form-select-option>
                                    <b-form-select-option v-for="(taxcard_month, index) in taxcard_months" :key="index"
                                        :value="taxcard_month.key">
                                        {{ taxcard_month.text }}
                                    </b-form-select-option>
                                </b-form-select>

                            </div>
                        </div>

                        <div class="col-md-9" v-if="selected_payslip.id > 0">
                            <div class="clearfix company-form-container h-100 p-3">
                                <template v-if="selected_payslip.finance_bill == 'new'">
                                    <taxcarddetailsnew-front :taxcard="selected_payslip.id"
                                        :company="companies[selected_payslip.company_id]"
                                        :cardname="'Tax Card for ' + empdata.name + ' - ' + selected_payslip.month + ' ' + selected_payslip.year"
                                        :pmonth="selected_payslip.month" :pyear="selected_payslip.year"
                                        :dynamic_fields="dynamic_fields" :key='detail_key'>
                                    </taxcarddetailsnew-front>
                                </template>
                                <template v-else>
                                    <taxcarddetails-front :taxcard="selected_payslip.id"
                                        :company="companies[selected_payslip.company_id]"
                                        :cardname="'Tax Card for ' + empdata.name + ' - ' + selected_payslip.month + ' ' + selected_payslip.year"
                                        :pmonth="selected_payslip.month" :pyear="selected_payslip.year"
                                        :dynamic_fields="dynamic_fields" :key='detail_key'>
                                    </taxcarddetails-front>
                                </template>

                            </div>
                        </div>
                        <div class="col-md-9" v-else>
                            <div class="clearfix company-form-container h-100 p-3">
                                <div class='no-data-wrapper'>
                                    No Data found
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </b-card>
        </b-overlay>
    </div>
</template>
<script>
export default {
    mounted() {
    },
    computed: {
    },
    data() {
        return {
            taxcards: [],
            empdata: [],
            companies: [],
            acccards: [],
            fiscal_years: [],
            fiscals: null,
            curr_fiscal: [],
            selected_payslip: {}, // fix: was [] / null causing Cannot read properties of null (reading 'id')
            tas: false,
            current_f_year: '',
            dynamic_fields: {},
            sa: null,
            detail_key: 0,
            activeIndex: -1,
            taxcard_months: [],
            selected_month_id: null,
        }
    },
    watch: {
        selected_month_id(val) {
            if (val) {
                this.handleMonthSelection(val);
            }
        }
    },
    methods: {
        validateState(ref) {
            if (
                this.veeFields[ref] &&
                (this.veeFields[ref].dirty || this.veeFields[ref].validated)
            ) {
                return !this.veeErrors.has(ref);
            }
            return null;
        },
        getTaxCards: function (f_year = '') {

            axios.get(this.$api_url + '/front/employeetaxcards', {
                params: {
                    fiscal_year: f_year
                }
            }).then(function (response) {

                this.taxcards = response.data.data.cards;

                this.empdata = response.data.data.employee_info;
                this.getPayslipDynamicFieldData(this.empdata.employee_id);

                this.companies = response.data.data.companies;
                this.fiscal_years = response.data.data.fiscal_years;

                this.curr_fiscal = response.data.data.fiscal_year;

                this.taxcard_months = [];

                if (this.curr_fiscal) {
                    this.fiscals = this.curr_fiscal;
                }

                // build dropdown list
                this.taxcards.forEach(element => {
                    this.taxcard_months.push({
                        key: element.id,
                        text: element.month + " " + element.year
                    });
                });

                if (this.taxcards.length > 0) {

                    let now = new Date();
                    let currentMonth = now.getMonth() + 1;
                    let currentYear = now.getFullYear();

                    let selected = this.taxcards[this.taxcards.length - 1];

                    let index = this.taxcards.indexOf(selected);

                    this.selected_month_id = selected.id;

                    this.paySlipLoad(selected.id, index);
                }
                else {
                    this.selected_payslip = {}; // fix: was null
                    this.activeIndex = -1;
                }

            }.bind(this));
        },
        paySlipLoad(card_id, index) {

            const id = parseInt(card_id);

            if (id) {

                this.activeIndex = index;

                this.selected_payslip = this.taxcards.find(item => item.id === id) || {};  // fix: was null

                console.log('Selected ID:', id);
                console.log('Selected Taxcard:', this.selected_payslip);

                this.detail_key += 1;

            } else {
                this.selected_payslip = {}; // fix: was null
                this.activeIndex = -1;
                this.detail_key += 1;
            }
        },
        getPayslipDynamicFieldData: function (emp_id) {
            axios.get(this.$api_url + '/front/company/payslip-field-settings/get-employee-dynamic-field-data').then(function (response) {
                var ltData = response.data;
                this.dynamic_fields = ltData;

            }.bind(this));
        },
        taxCardLoad(card_id) {
            if (parseInt(card_id)) {
                this.$set(this.acccards, card_id, 1);
            }
        },
        filterFiscalYear(f_year) {
            this.getTaxCards(f_year);
        },
        onSubmit: function (e) {
            this.$validator.validateAll().then(result => {
                if (!result) {
                    return;
                }
                e.preventDefault();
                let currentObj = this;
            });
        },

        handleMonthSelection(taxId) {
            const index = this.taxcards.findIndex(item => item.id === taxId)
            if (index !== -1) {
                this.paySlipLoad(taxId, index)
            }
            else {
                this.selected_payslip = {}, // fix: was null
                this.activeIndex = -1
            }
        },

    },
    created: function () {
        this.getTaxCards();
    }
}
</script>